import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const replace_all = (text, data, replace) => {
  if (data != replace) { while (text.includes(data)) { text = text.replace(data, replace) }}
  return text
}

const substitue_last = (text, word, data) => {
  let start_sub = text.lastIndexOf(word)
  let sub_final = start_sub + word.length
  return text.slice(0, start_sub) + data + text.slice(sub_final, text.leght)
}


const Lacuna = ({ className, item }) => {
  const [studentView, setStudentView] = useState(false);
  const handleView = () => { setStudentView(!studentView); };

  let auth = (dt) => [dt.length > 0, dt.includes('['), dt.includes(']')].every(e => e === true);

  const pergunta = item && item.comando_resposta ? item.comando_resposta : '';
  let pergunta_auth = auth(pergunta);

  const resposta = item && item.expectativa_resposta ? item.expectativa_resposta : '';
  let resposta_auth = auth(resposta);

  const enunciado_text = item && item.situacao_problema ? item.situacao_problema : '';

  // Authenticating resposta and pergunta
  if (resposta_auth && pergunta_auth) {

    // Get list with all the possible responses for each question
    // (list indx = sqt num - 1) -> question1 == response[0]
    let responses = [];
    let res = resposta.split('[').map(r => r.includes(']') ? r.split(']') : '');
    res = res.map(c => c[0]);
    res.map(r => {if (r != undefined) { responses.push(r.split('|')) }});


    // Creating the html string that allows the qst editor to check the lacunas responses
    let responses_visualization = []
    responses.map((resp) => responses_visualization.push("<p>" + resp.join(" - ") + "<p/>"))
    responses_visualization = responses_visualization.join("")


    // Treating the question to substituing the placeholders in the question
    let question = pergunta
    question = substitue_last(question, "]", "];")
    question = replace_all(question, "[", "<p>")
    question = replace_all(question, "];", "</p>")

    const enunciado = question

    // substituing the placeholders in the question
    let id = 0;
    let range = []
    while (question.includes("__")) {
      question = question.replace("__", `<input id="${id}"/>`)
      range.push(id)
      id ++
    }

    const is_correct = (data, idx, el) => {

      if (idx <= responses.length - 1 && responses[idx].includes(data)) { el.style.color = "#089C03" }
      else { el.style.color = "#f4ff" }
    }

    useEffect(() => {
      range.map(e => {
        let el = document.getElementById(e)
        el && el.addEventListener('change', (event) => is_correct(event.target.value, e, el))
      })
    });



  return (
    <div className={className}>
      <div className="btn">
        <button
          className="button"
          onClick={() => {
            handleView();
          }}
        >
          {!studentView ? 'Visualizar como estudante' : 'Visualizar resposta'}
        </button>
      </div>
      {studentView ? (
        <div style={{ padding: '1rem', width: '100%' }}>
          <div>
            <div className="conteiner">
              <div style={{ padding: '1rem', width: '100%' }}>
                  <div className="title">Enunciado: </div>
                  <div className="info">
                    <span
                      dangerouslySetInnerHTML={{ __html: enunciado_text }}
                    />
                  </div>
                </div>

                <div style={{ padding: '1rem', width: '100%' }}>
                  <div className="title"> Comando resposta: </div>
                  <div className="info">
                    <span dangerouslySetInnerHTML={{ __html: question }} />
                  </div>
                </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="conteiner">
              <div style={{ padding: '1rem', width: '100%' }}>
                <div className="title">Enunciado: </div>
                <div className="info">
                  <span
                    dangerouslySetInnerHTML={{ __html: enunciado_text }}
                  />
                </div>
              </div>

            <div style={{ padding: '1rem', width: '100%' }}>
              <div className="title"> Comando resposta: </div>
              <div className="info">
                <span dangerouslySetInnerHTML={{ __html: question }} />
              </div>
            </div>

            <div className="conteiner">
              <div style={{ padding: '1rem', width: '100%' }}>
                <div className="title"> Respostas aceitas: </div>
                <div className="info">
                  <span
                    dangerouslySetInnerHTML={{ __html: responses_visualization }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
  }

  else {
    return (
      <div className={className}>
        <div className="btn">
          <button
            style={{
              marginTop: '1rem',
              marginBottom: '3rem',
              outline: 'none',
              boxShadow: 'none',
              borderRadius:'70px', 
              backgroundColor:'gray',
              border: 'none',
              color:'white', 
              padding:'5px 23px'
            }}
            onClick={() => {
              handleView();
            }}
          >
            {!studentView ? 'Visualizar como estudante' : 'Visualizar resposta'}
          </button>
        </div>
        {studentView ? (
          <div style={{ padding: '1rem', width: '100%' }}>

            <div>
              <div className="conteiner">
                <div style={{ padding: '1rem', width: '100%' }}>
                  <div className="title"> Comando resposta: </div>
                  <div className="info">
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="conteiner">
              <div style={{ padding: '1rem', width: '100%' }}>
                <div className="title"> Comando resposta: </div>
                <div className="info">
                </div>
              </div>
              <div className="conteiner">
                <div style={{ padding: '1rem', width: '100%' }}>
                  <div className="title"> Respostas aceitas: </div>
                  <div className="info">
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
};

export default styled(Lacuna)`
  .conteiner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: #fff;
    width: 100%;
    border-radius: 8px;
    box-shadow: 0px 1px 4px rgba(54, 54, 54, 0.25);
    margin-top: 1rem;
  }
  .info {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 2rem;
    span {
      max-width: 100%;
    }
  }
  .title {
    width: 100%;
    font-size: 15px;
    display: flex;
    align-items: start;
    font-weight: bold;
    color:  ${(props) => (props.theme.primary)} !important;
    /* margin-left: 1rem; */
    margin-top: 1rem;
  }
  .button {
    background-color: ${(props) => (props.theme.primary)} !important;
    color: #fff;
    border: none;
    display: flex;
    margin-top: 10px;
    padding: 5px;
    letter-spacing: 1px;
    border-radius: 5px;
    box-shadow: none;
    outline: none;
    margin-left: -0.8rem;
  }
  .btn {
    padding-bottom: 20px;
    padding-left: 0px;
  }
`;
